import { ISubsidiary } from "../models/subsidiary.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { APIResponse } from "src/app/core/models/api-response";
import { Observable, of } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class SubsidiaryService {
  constructor(private http: HttpClient) {}

  public getAll(): Observable<APIResponse<ISubsidiary>> {
    return this.http.get<APIResponse<ISubsidiary>>(`${environment.BASE_URL_API}subsidiary-companies`);
  }
}